// extracted by mini-css-extract-plugin
export var cancelButton = "_n8-5";
export var content = "_n8-3";
export var createButton = "_n8-6";
export var drawerContainer = "_n8-0";
export var footer = "_n8-2";
export var header = "_n8-1";
export var orderFormColumn = "_n8-4";